import { Component, ElementRef, inject, viewChildren } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { AppendColorDirective } from '@demo/angular/demo-theme/append-color.directive';
import { CipoFormModule } from '@shared/modules';
import { NotificationService } from '@shared/services';

@Component({
  selector: 'app-color-palette',
  templateUrl: './color-palette.component.html',
  imports: [MatDialogModule, CipoFormModule, AppendColorDirective],
  styles: `
    .color-box {
      width: 140px;
      height: 50px;
    }

    input[type='color'] {
      background: none;
      border: none;
      height: 50px;
      width: 100px;
    }
  `,
})
export class ColorPaletteComponent {
  private notify = inject(NotificationService);
  private colorsRef = viewChildren<ElementRef>('color');

  readonly palettes = ['primary', 'accent', 'warn', 'black'];
  readonly hues = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900'];

  copyColorsJson() {
    const colors: { [key: string]: string } = {};
    this.colorsRef().forEach(({ nativeElement: { id, value } }) => (colors[id] = value));
    navigator.clipboard.writeText(JSON.stringify(colors)).then(() => this.notify.success('Colors copied'));
  }
}
